import React, { useState } from 'react';
import { useSport } from '../../../../../context/SportContext.tsx';
import { Schedule } from '../../../../../models/Schedule.tsx';
import AlertError from '../../../../alerts/AlertError.tsx';
import { SpecialDataComponent } from './SpecialDataComponent.tsx';

export function SpecialData() {
    const { gameEspecial, selectedGames } = useSport();
    const [showLimitAlert, setShowLimitAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showLimit, setShowLimit] = useState<Record<string, number>>({});

    const marketIds: string[] = Array.from(
        new Set(
            gameEspecial.flatMap((game: Schedule) =>
                game.odds?.map(o => o.market_id) ?? []
            )
        )
    );

    const gamesByMarket = marketIds.map((marketId) => {
        const filteredGames = gameEspecial
            .map((game: Schedule) => ({
                ...game,
                odds: game.odds?.filter(o => o.market_id === marketId)
            }))
            .filter((game: Schedule) =>
                game.odds?.length &&
                !game.is_live &&
                game.status === "unplayed"
            );

        return {
            marketId,
            games: filteredGames
        };
    });

    const hasOdds = gamesByMarket.some(m => m.games.length > 0);

    if (!selectedGames) return null;

    return (
        <>
            {!hasOdds && selectedGames && (
                <div className="no-data-games">
                    There are currently no odds available for this league.
                </div>
            )}
            {hasOdds && (
                <div className="containertable-parlay">
                    {gamesByMarket.map(({ marketId, games }) => {
                        if (!games.length) return null;
                        return (
                            <div key={marketId}>
                                {games.map((game: Schedule) => (
                                    <SpecialDataComponent
                                        key={`${marketId}-${game.game_id}`}
                                        game={game}
                                        marketId={marketId}
                                        showLimit={showLimit}
                                        setShowLimit={setShowLimit}
                                        setShowLimitAlert={setShowLimitAlert}
                                        setErrorMessage={setErrorMessage}
                                    />
                                ))}
                            </div>
                        );
                    })}
                </div>
            )}

            {showLimitAlert && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setShowLimitAlert(false)}
                />
            )}
            {errorMessage && (
                <AlertError
                    message={errorMessage}
                    onClose={() => setErrorMessage("")}
                />
            )}
        </>
    );
}
